import rules from '@anchor/vue-assets/src/plugins/form-rules';

export default {
  first_name: [
    rules.required,
  ],
  last_name: [
    rules.required,
  ],
  username: [
    rules.required,
  ],
  password: [
    rules.required,
    rules.min(6),
  ],
  confirm_password: [
    rules.required,
    rules.min(6),
  ],
  display_name: [
    rules.required,
  ],
  email: [
    rules.required,
    rules.email,
  ],
  title: [],
  phone: [],
  active: [
    rules.notNull,
  ],
  show_on_app: [
    rules.notNull,
  ],
};
